import SupplyIcon from '../components/SupplyIcon';
import { connect } from 'react-redux';
import {
  HStack,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';

const BallSupplyInput = ({ onBallSupplyChange, ballSupply }) => {
  const handleBallSupplyChange = valueString => {
    const newSupply = parseFloat(valueString);
    if (!isNaN(newSupply)) {
      onBallSupplyChange(newSupply); // Dispatch Redux action
    }
  };

  return (
    <HStack>
      <SupplyIcon boxSize={9} />
      <NumberInput
        id="BallSupply"
        size="md"
        maxW={20}
        min={0}
        defaultValue={180}
        value={ballSupply} // Get value from Redux store
        onChange={handleBallSupplyChange}
      >
        <NumberInputField borderRadius="none" borderColor="card.border" borderWidth="1px" />
        <NumberInputStepper>
          <NumberIncrementStepper borderRadius="none" />
          <NumberDecrementStepper borderRadius="none" />
        </NumberInputStepper>
      </NumberInput>
    </HStack>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    onBallSupplyChange: newBallSupply =>
      dispatch({ type: 'UPDATE_BALL_SUPPLY', payload: newBallSupply }),
  };
};

const mapStateToProps = state => {
  return {
    ballSupply: state.ballSupply,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BallSupplyInput);
